import React from 'react';
import './App.css';
import ToDo from "./ToDo"

function App() {
  return (
    <div className="App">
      <ToDo/>
    </div>
  );
}

export default App;
